var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ProgressIndicator.scss';
import Arrow from '../../assets/images/icons/RightArrow.png';
export var ProgressIndicator = function (_a) {
    var className = _a.className, _b = _a.data, isOnScreen = _b.isOnScreen, array = _b.array, onClick = _b.onClick, activeSlide = _b.activeSlide, showArrow = _b.showArrow;
    var scrollArrow = showArrow !== undefined ? showArrow : true;
    return (_jsxs("div", __assign({ className: "progress-indicator " + (isOnScreen ? 'fixed' : 'absolute') + " " + (className || '') }, { children: [array === null || array === void 0 ? void 0 : array.map(function (child, i) { return (_jsx("div", __assign({ className: "py-[20px] md:py-[24px] lg:py-[34.5px] cursor-pointer", onClick: function () { return onClick(i); } }, { children: _jsx("div", { className: (activeSlide === i
                        ? 'w-[50px] md:w-[50px] lg:w-[50px]'
                        : 'w-[30px] md:w-[30px] lg:w-[30px]') + " h-[1px] mx-[8px] " + (activeSlide === i
                        ? 'bg-enblue-900'
                        : 'bg-enblue-900 inactive-indicator'), onClick: function () { return onClick(i); } }, void 0) }), "indicator-" + i)); }),
            array.length - 1 === activeSlide && scrollArrow && (_jsxs("div", __assign({ className: "text-container absolute bottom-[12px] md:bottom-[16px] lg:bottom-[40px] right-[15px] md:right-[40px] lg:right-[155px] text-[12px] md:text-[14px] text-[#343741] z-20 bg-white" }, { children: [_jsx("span", __assign({ className: "text mr-[12px]" }, { children: "Scroll" }), void 0),
                    _jsx("img", { src: Arrow, className: "arrow" }, void 0)] }), void 0))] }), void 0));
};
